import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingInfoService {
  public previousUrlValue: string; // todo: this needs to be an array of previous URLs upto 5
  public previousUrlValueArray: any[] = [];
  private previousUrl: ReplaySubject<string> = new ReplaySubject<string>(1);

  constructor() {}

  public setValue(value: string): void {
    this.previousUrl.next(value);
    this.previousUrlValue = value;
    if (this.previousUrlValueArray.length < 5) {
      this.previousUrlValueArray.push(value);
    } else {
      this.previousUrlValueArray.splice(0, 1);
      this.previousUrlValueArray.push(value);
    }
  }

  public getValue(): Observable<string> {
    return this.previousUrl;
  }
}
